var app = globalThis;

app.Modal = (function() {
  Modal.getModalObject = function($html) {
    var module;
    module = $html.data('modal-module');
    if (this.NAMESPACE.hasOwnProperty(module) && this.NAMESPACE[module] instanceof Function) {
      return new this.NAMESPACE[module]($html);
    } else {
      return new app.Modal($html);
    }
  };

  function Modal($html) {
    this.$html = $html;
  }

  Modal.prototype.getDOMId = function() {
    return this.$html.attr('id');
  };

  Modal.prototype.setLevel = function(level) {
    return this.$html.data('level', level);
  };

  Modal.prototype.getLevel = function() {
    return this.$html.data('level') || 1;
  };

  Modal.prototype.getTargetDOMid = function() {
    return this.$html.data('target');
  };

  Modal.prototype.getTargetDOM = function() {
    var $target, targetId;
    targetId = this.getTargetDOMid();
    $target = $("#" + targetId);
    if ($target.length) {
      return $target;
    } else {
      return false;
    }
  };

  Modal.prototype.init = function() {
    if (this.$html.hasClass('initialized')) {
      return this;
    }
    this.$html.addClass('initialized');
    $(window).keydown((function(_this) {
      return function(e) {
        var key;
        key = e.which;
        if (key === 27) {
          return _this.close();
        }
      };
    })(this));
    return this;
  };

  Modal.prototype.applyOptions = function(options) {
    if (options.modalLevel && options.modalLevel > 0) {
      this.$html.css('z-index', 7100 + options.modalLevel);
      this.setLevel(options.modalLevel);
    }
    if (options.focus && options.focus.length > 0) {
      return this.$html.find("*[name=" + options.focus).first().focus();
    }
  };

  Modal.prototype.open = function(options, callback) {
    var _this = this;
    if (!this.$html) {
      console.log('Modale non définie');
      return false;
    }
    this.applyOptions(options);
    if (options.keepscroll == null) {
      $('body').addClass('no-scroll');
    }
    this.$html.fadeIn(300, function() {
      if (!_this.$html.hasClass('initialized')) {
        _this.init();
      }

      if (typeof callback === 'function') {
        return callback();
      }
    });
    if (options.focus != null) {
      this.$html.find('input[data-autofocus="true"]').first().focus();
    }
    return this;
  };

  Modal.prototype.close = function() {
    var $html;
    if (this.$html != null) {
      $html = this.$html;
      if (this.getLevel() === 1) {
        if (app.modalLoader != null) {
          app.modalLoader.finish((function(_this) {
            return function() {
              return $html.remove();
            };
          })(this));
        } else {
          $html.remove();
        }
        $('body').removeClass('no-scroll');
      } else {
        $html.remove();
      }
      return app.currentModal = null;
    }
  };

  Modal.prototype.submit = function(params) {
    var $form, url, values;
    if (app.loader != null) {
      app.loader.start();
    }
    if (params == null) {
      params = {};
    }
    if (params.callbackSuccess == null) {
      params.callbackSuccess = (function(_this) {
        return function(data) {
          return _this.callbackSuccess(data);
        };
      })(this);
    }
    if (params.callbackError == null) {
      params.callbackError = (function(_this) {
        return function(data) {
          return _this.callbackError(data);
        };
      })(this);
    }
    $form = this.$html.find('form').first();
    values = $form.serialize();
    url = $form.attr('action');
    return $.post(url, values, params.callbackSuccess, 'json').fail(params.callbackError);
  };

  Modal.prototype.callbackSuccess = function(data, successMsg) {
    if (data == null) {
      data = {};
    }
    if (data.response) {
      this.updateView(data);
      this.close();
      if (app.loader != null) {
        return app.loader.success(successMsg);
      }
    } else {
      if (app.loader != null) {
        return app.loader.error();
      }
    }
  };

  Modal.prototype.callbackError = function(data) {
    if (app.loader != null) {
      return app.loader.error();
    }
  };

  Modal.prototype.updateView = function(response) {};

  return Modal;

})();

app.ModalOpener = (function() {
  ModalOpener.MAIN_CLASS = 'open-modal';

  ModalOpener.NAMESPACE = '/api';

  function ModalOpener($html) {
    this.$html   = $html;
    this.options = {};
    if (this.$html.hasClass(this.constructor.MAIN_CLASS)) {
      this.$html;
    }
  }

  ModalOpener.initModalOpeners = function(callback) {
    var self;
    self = this;
    $('body').on('click', "." + this.MAIN_CLASS, function(e) {
      e.preventDefault();

      var opener,
          $this = $(this);

      $('body').trigger('modals.opening', [$this])

      if (app.modalLoader != null) {
        app.modalLoader.loading();
      }
      opener = new self($this);
      opener.openModal();
      if (callback instanceof Function) {
        callback(opener);
      }
      return false;
    });
    return $(window).keydown(function(e) {
      var key;
      key = e.which;
      if (key === 27 && !app.currentModal) {
        self.abortXHR();
        if (app.modalLoader != null) {
          return app.modalLoader.finish();
        }
      }
    });
  };

  ModalOpener.abortXHR = function() {
    if (this.XHR) {
      return this.XHR.abort();
    }
  };

  ModalOpener.prototype.getModalTarget = function(callback) {
    var data, self, url;
    self = this;
    data = {};
    url = this.$html.data('modal-url');
    if (url == null) {
      this.options = this.getOptions();
      if (this.options.key) {
        url = this.constructor.NAMESPACE + "/modals/" + this.options.key;
      } else {
        console.log('Aucune clé');
        return false;
      }
      if (this.options.id) {
        url += "/" + this.options.id;
      }
      if (this.options.context) {
        data.context = this.options.context;
      }
      if (this.options.data) {
        data = $.extend(data, this.options.data);
      }
      if (this.options.attributes) {
        data.attributes = JSON.stringify(this.options.attributes);
      }
    }

    return this.constructor.XHR = $.get(url, data, (function(_this) {
      return function(data, response, xhr) {
        var $modal, modalAppended;
        _this.constructor.XHR = false;
        if (data.response) {
          $modal = $(data.html);
          if (app.modalLoader != null) {
            if (app.modalLoader.removeLoading != null) {
              app.modalLoader.removeLoading().append($modal);
              modalAppended = true;
            } else {
              app.modalLoader.finish();
            }
          }
          if ($.fn.modal instanceof Function) {
            $modal.modal('show');
            modalAppended = true;
          }
          if (modalAppended == null) {
            $('body').append($modal);
          }
          app.currentModal = app.Modal.getModalObject($modal);
          app.currentModalOpener = self;
          return callback.call(self, app.currentModal);
        } else {
          if (app.modalLoader != null) {
            return app.modalLoader.finish();
          }
        }
      };
    })(this), 'json').fail(function() {
      if (app.modalLoader != null) {
        app.modalLoader.finish();
      }
      return console.log('Erreur de chargement');
    });
  };

  ModalOpener.prototype.getOptions = function() {
    var options;
    options = this.$html.data('modal-options') || {};
    options.modalLevel = options.modalLevel != null ? parseInt(options.modalLevel) : 1;
    return options;
  };

  ModalOpener.prototype.openModal = function() {
    return this.getModalTarget(function(modal) {
      return modal.open(this.options);
    });
  };

  return ModalOpener;
})();
